import React from "react";

import heroImage from "../../assets/images/Goget One (2nd).webp";
import frontImage from "../../assets/images/Goget Device front.webp";
import sideImage from "../../assets/images/Goget Device side.webp";
import sideProfileImage from "../../assets/images/Goget Device side2.webp";
import completeImage from "../../assets/images/Goget Device complete.webp";
import backImage from "../../assets/images/Goget Device back.webp";
import backAltImage from "../../assets/images/Goget Device back2.webp";

import { Button } from "../shared/Button/Button";
import { ZoomImage } from "../shared/ZoomImage/ZoomImage";
import { PRODUCT_STORE_FEATURED } from "./ProductStore.catalog";
import { ProductStoreAction, ProductStorePricing } from "./ProductStore.types";
import { getProductOffer } from "./productStorePricing";

const GALLERY = [
  { src: frontImage, alt: "GOGET One front view" },
  { src: sideProfileImage, alt: "GOGET One side profile" },
  { src: completeImage, alt: "GOGET One mounting system" },
  { src: sideImage, alt: "GOGET One bottom view with ports" },
  { src: backAltImage, alt: "GOGET One wall mount plate" },
  { src: backImage, alt: "GOGET One rear view" },
];

interface Props {
  pricing: ProductStorePricing;
  openingProductType?: string;
  onAction: (action: ProductStoreAction) => void;
}

export const ProductStoreFeatured = ({
  pricing,
  openingProductType,
  onAction,
}: Props) => {
  const product = PRODUCT_STORE_FEATURED;
  const offer = getProductOffer(pricing, {
    title: product.title,
    pricing: product.pricing,
    purchase: product.purchase,
    ctaLabel: "Order now",
    action: product.primaryAction,
  });
  const { action } = offer;
  const isCheckout = action.type === "checkout";
  const opening = isCheckout && openingProductType === action.productType;

  return (
    <article className="ProductStoreFeatured" aria-labelledby="featured-title">
      <div className="ProductStoreFeatured__hero">
        <img
          src={heroImage}
          alt="GOGET One room panel with green status lights"
        />
      </div>
      <div className="ProductStoreFeatured__content">
        <div className="ProductStoreFeatured__main">
          <span className="ProductStoreFeatured__eyebrow">
            {product.eyebrow}
          </span>
          <h2 id="featured-title">{product.title}</h2>
          <p>{product.description}</p>
          <ul
            className="ProductStoreFeatured__features"
            aria-label="Highlights"
          >
            {product.features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>
        <div
          className="ProductStoreFeatured__gallery"
          aria-label="Product views"
        >
          {GALLERY.map((image) => (
            <ZoomImage src={image.src} alt={image.alt} key={image.alt} />
          ))}
        </div>
        <div className="ProductStoreFeatured__footer">
          <div aria-busy={offer.loading || undefined}>
            {offer.loading ? (
              <span className="ProductStoreFeatured__pricePlaceholder" />
            ) : offer.message ? (
              <span className="ProductStoreFeatured__priceMessage">
                {offer.message}
              </span>
            ) : (
              <>
                <span>Price</span>
                <strong>{offer.price}</strong>
              </>
            )}
          </div>
          <div className="ProductStoreFeatured__actions">
            <Button
              title={offer.ctaLabel}
              loadSpinner={opening}
              loadTitle="Opening"
              disabled={
                offer.ctaDisabled || (isCheckout && !!openingProductType)
              }
              onClick={() => onAction(action)}
            />
            <Button
              title="View product details"
              className="ProductStoreFeatured__detailsButton"
              onClick={() => onAction(product.secondaryAction)}
            />
          </div>
        </div>
      </div>
    </article>
  );
};
